import React from "react";
import { CheckboxIcon } from "@sonder/ui/source/styled/fragments/CheckboxIcon";
import { CheckboxWithLabel } from "@sonder/ui/source/styled/fragments/CheckboxWithLabel";
import { FilterGroupItem } from "@sonder/ui/source/styled/fragments/GenericFilters";
import { Label } from "@sonder/ui/source/styled/fragments/Label";
import { mapCheckoutStatusToDisplayName } from "checkouts/helpers";
import { InquiryCheckoutStatus } from "typings/globalGQLTypes";

interface CheckoutStatusFilterGroupItemProps {
  isChecked: boolean;
  checkoutStatus: InquiryCheckoutStatus;
  onClick(): void;
}

export const CheckoutStatusFilterGroupItem = ({
  isChecked,
  checkoutStatus,
  onClick,
}: CheckoutStatusFilterGroupItemProps) => {
  return (
    <FilterGroupItem fullWidth noBorder type="button" onClick={onClick}>
      <CheckboxWithLabel title={checkoutStatus}>
        <CheckboxIcon checked={isChecked} />
        <Label>{mapCheckoutStatusToDisplayName(checkoutStatus)}</Label>
      </CheckboxWithLabel>
    </FilterGroupItem>
  );
};
